import { ProductHatProps } from '@wix/package-picker-components';
import { useTranslation } from 'react-i18next';

export const useHatProperties = ({
  isCurrentPlan,
  isOnSale,
  isRecommended,
  text,
}: {
  isCurrentPlan?: boolean;
  isOnSale?: boolean;
  isRecommended?: boolean;
  text?: string;
}): ProductHatProps | undefined => {
  const { t } = useTranslation();
  let hatProperties;
  if (isRecommended) {
    hatProperties = {
      hatText: t(text || 'premium-purchase-plan.cards.hat.recommended'),
    };
  }
  if (isOnSale) {
    hatProperties = {
      hatText: t('premium-purchase-plan.cards.hat_sale', '50% OFF'),
      background: '#FF784B',
    };
  }
  if (isCurrentPlan) {
    hatProperties = {
      hatText: t('premium-purchase-plan.cards.hat.current_plan'),
      background: '#EBEBEB',
      textWhite: false,
    };
  }
  return hatProperties;
};
